import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Style
import useStyles from '../../../../assets/styles/components/cards/itemListProgramCard/itemListProgramCardContentStyle';

// Material components
import { Box, Chip, Icon, Typography } from '@material-ui/core';

// Constants
import { WHITE } from '../../../../constants/color-images';
import { CHIP_CLASSNAME, LEVEL_NAME } from '../../../../constants/levels';

// Icons
import { ReactComponent as MisCursosFillSVG } from '../../../../assets/images/icons/mis-cursos-fill.svg';

// Components
import LogoSource from '../../../LogoSource/LogoSource';
import PriceAndMembership from '../../components/PriceAndMembership';

const ItemListProgramCardContent = ({backgroundImage, expandArrowIcon, onClickExpandSection, sourceId, name, levelId, hasDetail, content, membershipIdList}) => {
    const classes = useStyles({backgroundImage, hasDetail});

    return (
        <Box className={classes.rootItemListProgramCardContent}>
            <Box className={classes.principalContainer}>
                <Box className={classes.dataContainer}>
                    <Box className={classes.iconsContainer}>
                        <Icon component={MisCursosFillSVG} className={clsx(classes.misCursosFillSVGIcon)}/>
                        <Box display="flex" alignItems="center">  
                            <LogoSource sourceId={sourceId} disabledAutoRes color={WHITE} className={classes[`logoCompany${sourceId}`]}/>
                        </Box>
                    </Box>
                    <Typography variant="h4" className={clsx(classes.name)}>{name}</ Typography>
                    <Box mt={"6px"}>
                        <Chip label={LEVEL_NAME[levelId]} className={clsx("semi-bold", CHIP_CLASSNAME[levelId])} />  
                    </Box>
                </Box>
                {
                    !hasDetail &&
                    <Box className={classes.priceAndMembershipContainer}>
                        <PriceAndMembership isResponsive={true} content={content} isProgram membershipIdList={membershipIdList}/>
                    </Box>
                }
            </Box>
            {
                hasDetail && 
                <Box className={clsx(classes.expandContainer, classes[`expandSection${levelId}BG`])} onClick={onClickExpandSection}>
                    <Icon className={clsx(!expandArrowIcon && 'ri-arrow-down-s-line', expandArrowIcon && 'ri-arrow-up-s-line', 'font-size-24')}/>
                </Box>
            }
        </Box>
    );
};

ItemListProgramCardContent.defaultProps = {
    expandArrowIcon: false,
    hasDetail: false,
};

ItemListProgramCardContent.propTypes = {
    backgroundImage: PropTypes.string.isRequired,
    expandArrowIcon: PropTypes.bool,
    onClickExpandSection: PropTypes.func,
    sourceId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    levelId: PropTypes.string.isRequired,
    hasDetail: PropTypes.bool,
    content: PropTypes.shape({
        price: PropTypes.shape({
            number: PropTypes.number,
            listNumber: PropTypes.number,
        }),
        showLabel: PropTypes.bool.isRequired,
        showPrice: PropTypes.bool.isRequired,
        labelToShow: PropTypes.string.isRequired,
        typeLabel: PropTypes.number.isRequired,
    }).isRequired,
    membershipIdList: PropTypes.arrayOf(PropTypes.number),
};

export default ItemListProgramCardContent;